<template>
    <body class="white-bg">
        <div>
            <div id="form" class="ibox page-full">
                <div class="r-header">SK텔레콤 노동조합 {{ clazz }}후보 추천</div>
                <div>
                    <div class="progress">
                        <div role="progressbar" aria-valuenow="35" aria-valuemin="0" aria-valuemax="100" class="progress-bar progress-bar-warning" style="width: 0%;">0%</div>
                    </div>
                </div>
                <div class="r-box no-borders m-0">
                    <div id="question_0" style="display: block;">
                        <div class="r-ques">
                            <div align="center" style="margin : 0px 0px 10px 0px; padding: 2px; background-color:#0100FF">
                                <b>
                                    <span style="color:white">
                                        SK텔레콤 노동조합<br>[{{subject}}]
                                    </span>
                                </b>
                            </div>
                            〔{{clazz}} 입후보자〕 <br/>
                            {{district}} / {{team}} 소속<br/>
                            <b>{{name}}</b>({{employeeNumber}}) 후보<br/><br/>

                            <span v-for="partner in partners" v-bind:key="partner">
                              〔{{partner.clazz}} 입후보자〕<br/>
                              {{district}} / {{partner.team}} 소속<br/>
                              <b>{{partner.name}}</b>({{partner.employeeNumber}}) 후보<br/><br/>
                            </span>

                            〔입후보 소견〕 <br/>
                            {{opinion}}

                            <hr style="border: dashed 1px gray;">
                            귀하께서는 <b>{{name}}</b><b v-for="partner in partners" v-bind:key="partner">,{{partner.name}}</b>
                            후보를 추천하십니까?
                        </div>
                        <!---->
                        <div>
                            <div>
                                <div class="r-exam" @click="clickItem">
                                    <div style="flex-grow: 0;">
                                        <input type="radio" id="4-0" name="4" :checked="nomiateValue">
                                    </div>
                                    <div style="flex-grow: 1;">
                                        <span style="margin-left: 10px;">
                                            <b>추천</b>
                                        </span>
                                    </div>
                                    <img src="@/assets/img/vote.png" class="r-hide" style="flex-grow: 0;">
                                </div>
                            </div>
                            <div style="flex-grow: 1; display: none;">
                                <span class="r-bottom-text"></span>
                            </div>
                        </div>
                    </div>
                    <div id="pageEnd" class="r-text-center mt-5 mb-2">
                        <!-- <button id="nextPage" class="btn btn-success r-btn-width" style="display: none;">투표</button> -->
                        <button id="nextPage" class="btn btn-success r-btn-width" @click="next">추천 제출</button>
                        <button v-if="isOwnCandidate" class="btn btn-primary r-btn-width mt-2" @click="goToReport">현황 확인</button>
                    </div>
                </div>
            </div>
            <div class="r-footer"></div>
        </div>
    </body>
</template>

<script>
import Service from '@/services/RecommendService'

export default {
  name: 'recommend-vote',
  props: {
    msg: String
  },
  data() {
    return {
        hash: null,
        subject: null,
        clazz: null,
        name: null,
        employeeNumber: null,
        team: null,
        partners: null,
        opinion: null,
        district: null,
        nomiateValue: null,
        isOwnCandidate: false,
        currentUserPhone: null,
    }
  },
  mounted() {
      window.scrollTo(0, 0)
      this.hash = this.$route.params.hash

      Service.getCandidateInfo(this.hash,
        (data_ok) => {
          if (!data_ok.success) {
            alert(data_ok.message)
            this.$router.push({name: 'recommend-home'})
            return
          }

            const candidate = data_ok.data.candidate
            const topic = data_ok.data.topic
            this.subject = topic.title
            this.clazz = topic.clazz
            this.name = candidate.name
            this.employeeNumber = candidate.employeeNumber
            this.team = candidate.team
            this.partners = candidate.partners
            this.opinion = candidate.candidacyOpinion
            this.district = candidate.electionWard
            
            // Set if current user is the candidate owner
            this.isOwnCandidate = data_ok.data.isOwner
        }
      )
  },
  methods: {
      clickItem() {
          this.nomiateValue = 'on'
          this.$forceUpdate()
      },
      
      next() {
          if (!this.nomiateValue) {
             alert("추천을 위해 추천 항목을 체크해주시기 바랍니다.")
             return
          }

          Service.recommend(this.hash,
              (data_ok) => {
                  if (!data_ok.success) {
                      alert(data_ok.message)
                      return
                  }

                  this.$router.push({name: 'recommend-complete', params: {mode:'nominate'}})
              }
          )
      },
      
      goToReport() {
          this.$router.push({name: 'recommend-report', params: {hash: this.hash}})
      },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
